<template>
    <div id="comOrderlist">
        <div >
            <div class="mybreadcrumb">
                <i class="iconfont icon-biaodan" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>订单和计费</el-breadcrumb-item>
                    <el-breadcrumb-item>我的订单</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="allorder">所有订单({{total}})</div>
            <div class="table-wraper">
                <el-table
                ref="ordertable"
                :data="tableData"
                border
                class="eleltable"
                :header-cell-style="{color:'#666666',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'10px 0',background:'#F5F5F5'}"
                :cell-class-name="tabCellClassName"
                
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{(pageIndex-1) * pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                    <el-table-column
                    prop="orderNo"
                    label="订单编号"
                    show-overflow-tooltip
                    align="center">
                    </el-table-column>
                    <el-table-column
                    prop="productName"
                    label="产品名称"
                    show-overflow-tooltip
                    align="center">
                    </el-table-column>
                    
                    <el-table-column
                    prop="createdAt"
                    label="下单时间"
                    align="center"
                    show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                
                    label="订单状态"
                    width="100"
                    align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.tradeStatus==='PAYERROR'" class="table-status bgcred">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='SUCCESS'" class="table-status bgcgreen">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='NOTPAY'" class="table-status bgcorange">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='CLOSED'" class="table-status bgcgrey">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='COMPLETED'" class="table-status bgcgrey">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='PROCESSING'" class="table-status bgcblue">
                                <el-tooltip content="网银支付成功后，需1-2个工作日进行处理并更新订单状态" placement="top">
                                    <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                                </el-tooltip>
                            </div>
                            <div v-else>
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                    prop="payAmount"
                    label="应付金额(元)"
                    width="80"
                    align="center">
                    </el-table-column>
                    <el-table-column
                    prop="actualAmount"
                    width="80"
                    label="实付金额(元)"
                    align="center">
                    </el-table-column>

                    <el-table-column
                    label="操作"
                    width="240"
                    align="center">
                    <template slot-scope="scope">
                        <div v-show="scope.row.tradeStatus==='NOTPAY'" style="display:flex;justify-content:space-around">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                            <div class="common-btn-table" @click="confirmMessage('cancle',scope.row)" style="width:48px">取消</div>
                            <div class="common-btn-table" @click="repayClick(scope.row)" style="width:76px">继续支付</div>
                        </div>
                        <div v-show="scope.row.tradeStatus==='SUCCESS'" style="display:flex;justify-content:center">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                        </div>
                        <div v-show="scope.row.tradeStatus==='COMPLETED'" style="display:flex;justify-content:center">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                            <div  @click="confirmMessage('delete',scope.row)" class="common-btn-table" style="width:48px;margin-left:5px">删除</div>
                        </div>
                        <div v-show="scope.row.tradeStatus==='PAYERROR'" style="display:flex;justify-content:space-around">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                            <div class="common-btn-table" @click="confirmMessage('cancle',scope.row)" style="width:48px">取消</div>
                            <div class="common-btn-table" @click="repayClick(scope.row)" style="width:76px">继续支付</div>

                        </div>
                        <div v-show="scope.row.tradeStatus==='CLOSED'" style="display:flex;justify-content:center">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                            <div  @click="confirmMessage('delete',scope.row)" class="common-btn-table" style="width:48px;margin-left:5px">删除</div>
                        </div>
                        
                        <div v-show="scope.row.tradeStatus==='ACCEPT'" style="display:flex;justify-content:center">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                        </div>
                        <div v-show="scope.row.tradeStatus==='PROCESSING'" style="display:flex;justify-content:center">
                            <div class="common-btn-table" @click="goOrderDetail(scope.row)" style="width:76px">查看详情</div>
                        </div>

                    </template>
                    </el-table-column>
                </el-table>
            </div>
            
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                style="margin-top:20px;padding-bottom:30px">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {EnterpriseOrderListApi,DeleteEnterpriseOrderApi,CancelEnterpriseOrderApi} from '@/js/enterPriseApi.js'
import Moment from 'moment';
export default {
    name:'companyorder',
    computed:{
        arrlength(){
            return this.tableData.length
        }
    },
    data(){
        return{
          ismobile:false,
          tableData: [],
          pageSize:10,
          pageIndex:1,
          total:0,
          hasPreviousPage:false,
          response:[
          ]
      } 
    },
    created() {
        this.getOrderList({
            pageIndex:1,
            pageSize:10,
        })
    },
    filters:{
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        dateModify(val){
            return Moment(val).format('YYYY-MM-DD HH:mm:ss')
        },
        tradeStatusModify(val){
            if(val==='SUCCESS'){
                return '支付成功'
            }else if(val==='NOTPAY'){
                return '待支付'
            }else if(val==='CLOSED'){
                return '已关闭'
            }else if(val==='PAYERROR'){
                return '支付失败'
            }else if(val==='COMPLETED'){
                return '已完成'
            }else if(val=='PROCESSING'){
                return '处理中'
            }else if(val=='ACCEPT'){
                return '已接收,待扣款'
            }else{
                return val
            }
        }
    },
    methods:{
        expand(){
            
        },
        tabRowClassName({row,rowIndex}){//el-table样式回调
		        return 'rowstyle'
        },
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        confirmMessage(operatetype,params){
            let that=this; 
            if(operatetype==='cancle'){
               this.$confirm('您确定要取消该订单吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    that.cancleOrder(params)
                }).catch(() => {  

                });
           }else{
               this.$confirm('您确定要删除该订单吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    that.deleteOrder(params)
                }).catch(() => {  

                });
           }
           
        },
        repayClick(row){
            this.$router.push({
                path:'/SalePayPage',
                query:{
                    orderNo:row.orderNo
                }
            })
        },

        handleSizeChange(val){//每页多少改变触发
            this.pageSize=val;
            this.getOrderList({
                pageIndex:this.pageIndex,
                pageSize:val
            })
        },
        handleCurrentChange(currentpage){//当前页数切换
            let that=this;
            this.pageIndex=currentpage
            that.getOrderList({
                pageIndex:this.pageIndex,
                pageSize:that.pageSize
            })
        },
        getOrderList(params){//获取订单列表
            let that=this;
            params.enterpriseId=localStorage.getItem('enterPriseId')
            EnterpriseOrderListApi(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    that.tableData=[];
                    that.total=0;
                    const {data}=res.data;
                    that.total=data.totalItems;
                    that.hasPreviousPage=data.hasPreviousPage;
                    data.list.forEach(item=>{
                        let itemobj={
                            orderNo:item.orderNo,
                            payAmount:item.payAmount+'元',
                            actualAmount:item.actualAmount,
                            createdAt:Moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
                            productName:item.productName,
                            tradeStatus:item.orderStatus.name,
                        }
                        that.tableData.push(itemobj);
                    })
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data);
                }
            })
        },
        cancleOrder(row){//取消订单
            let that=this;
            CancelEnterpriseOrderApi(row.orderNo)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    that.$message.success('订单取消成功');
                    that.getOrderList({
                        pageIndex:that.pageIndex,
                        pageSize:that.pageSize
                    });
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data);
                }
            })
        },
        deleteOrder(row){//删除订单
            let that=this;
            if(that.tableData.length===1){//判断当前页只有一行
                if(that.hasPreviousPage===true){//判断当前页有上一页
                    that.pageIndex=that.pageIndex-1;
                }else{
                    that.pageIndex=1;
                }
            }else{//判断当前页有多行
                that.pageIndex=that.pageIndex
            }
            
            DeleteEnterpriseOrderApi(row.orderNo)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    that.$message.success('订单删除成功');
                    that.getOrderList({
                        pageIndex:that.pageIndex,
                        pageSize:that.pageSize
                    });
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data);
                }
            })
        },
        goOrderDetail(row){//前往订单详情页面
            this.$router.push({
                path:'/comOrderDetail',
                query:{
                    orderNo:row.orderNo
                }
            })
        }
        
    }
}
</script>


<style lang="scss" scoped>
    #comOrderlist{
        width: 100%;
        background: #fff;
        min-height: 100%;
        //padding-right: 30px;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            align-items: center;
            padding: 13px 0 13px 20px;
            border-bottom: 1px solid #EAEAEA;
        }
        .allorder{
            margin-top: 20px;
            margin-left: 30px;
            text-align: left;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333;
            font-weight: 700;
        }
        .table-wraper{
            padding: 15px 30px;
            .common-btn-table{
                    padding: 0 11px;
                    height: 28px;
                    line-height: 28px;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #0069E0;
                    background: #F0F6FD;
                    border: 1px solid rgba(0,105,224,0.45);
                    border-radius: 2px;
                    cursor: pointer;
                }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcred::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #fe3d3d;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .bgcgrey::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #C8C8C8;
        }
        .bgcblue::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #0069e0;
        }

        //element-ui样式
        /deep/ .el-table .cellstyle{
            //padding: 10px 0 !important;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
            padding: 0;
            height: 40px;//记录
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanyOrderPay/companyOrder.vue